/** Эпоха устройства: число, которое меняется при каждом стирании.
 *
 *  Нужна ровно для одного. Обмен уходит в сеть на секунды, и за это время
 *  родитель успевает выйти: `wipeDevice` чистит таблицы, а ответ сервера
 *  приходит позже и кладёт на стёртое устройство детей и журналы прежней
 *  семьи. Экран после выхода здоров, события в Sentry нет — а стирание
 *  существует ровно затем, чтобы следующий за общим планшетом не увидел
 *  чужого. Измерено исполнением: `tests/data/lifecycle.test.ts`.
 *
 *  Обмен снимает эпоху в начале и сверяет её с текущей перед каждым
 *  запросом к серверу и ВНУТРИ каждой своей транзакции записи. Стирание
 *  поднимает эпоху первым действием, до своей транзакции. Отсюда порядок:
 *  транзакция обмена, открытая раньше стирания, кончается раньше его
 *  чистки, и её строки вычищаются; открытая позже видит новую эпоху и не
 *  пишет ничего.
 *
 *  Число живёт в памяти модуля, а НЕ в базе, и это решение, а не
 *  упрощение. Эпоха обязана пережить стирание базы — иначе стирание
 *  сбросило бы и её, — и не обязана переживать перезагрузку страницы:
 *  после перезагрузки обменов прежней эпохи не существует.
 *
 *  Цена, которую это решение называет честно: другая вкладка того же
 *  браузера держит свою копию модуля и о стирании не узнаёт. Записано в
 *  `docs/OPEN.md`, раздел 6.3. */
let текущая = 0;

export function эпоха(): number {
  return текущая;
}

export function новаяЭпоха(): void {
  текущая += 1;
}
